import { Page } from '@/core/architecture'

import { GlobalArtistTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * GlobalArtist Page
 * Implemented as a practical sample.
 */
export const GlobalArtist: Page = () => {
  const { state, actions } = useViewModel()

  return <GlobalArtistTemplate state={state} />
}
